if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const getCurrentQuantityInCart = async (variantId) => {
          try {
            const response = await fetch("/cart.js");
            const cart = await response.json();
            const lineItem = cart.items.find(
              (item) => item.variant_id === variantId
            );
            return lineItem ? lineItem.quantity : 0;
          } catch (error) {
            console.error("Error fetching cart data:", error);
            return 0;
          }
        };

        const getSelectedQuantity = () => {
          const quantityInput = document.querySelector(
            'input[name="quantity"]'
          );
          return quantityInput ? parseInt(quantityInput.value, 10) : 1;
        };

        const checkInventory = (
          currentQuantity,
          selectedQuantity,
          maxInventory
        ) => currentQuantity + selectedQuantity <= maxInventory;

        const warnMsg = document.querySelector("#warn-msg");
        const addToCartButton = document.querySelector(
          ".product-form__submit:not([disabled])"
        );
        const form = addToCartButton.closest("form");
        const variantId = JSON.parse(
          form.querySelector('input[name="id"]').value
        );

        getCurrentQuantityInCart(variantId).then((currentQuantityInCart) => {
          const selectedQuantity = getSelectedQuantity();
          const inventoryQuantity = parseInt(
            addToCartButton.getAttribute("data-inventory-quantity"),
            10
          );

          const isContinue =
            addToCartButton.getAttribute("data-inventory-policy") ===
            "continue";
          if (
            !checkInventory(
              currentQuantityInCart,
              selectedQuantity,
              inventoryQuantity
            ) &&
            !isContinue
          ) {
            evt.preventDefault();
            warnMsg.style.display = "block";
          } else {
            if (this.submitButton.getAttribute("aria-disabled") === "true")
              return;

            this.hideErrors = false;
            warnMsg.style.display = "none";

            this.handleErrorMessage();

            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.classList.add("loading");
            this.querySelector(".loading__spinner").classList.remove("hidden");

            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];

            const formData = new FormData(this.form);
            if (this.cart) {
              formData.append(
                "sections",
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append("sections_url", window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  if (response.status === 422) {
                    const productIdToRemove = formData.get("id");
                    this.updateProductQuantityInCart(productIdToRemove, 0);
                  }
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);
                  const soldOutMessage =
                    this.submitButton.querySelector(".sold-out-message");
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute("aria-disabled", true);
                  this.submitButtonText.classList.add("hidden");
                  soldOutMessage.classList.remove("hidden");
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    cartData: response,
                  });
                this.error = false;

                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove("loading");
                if (this.cart && this.cart.classList.contains("is-empty"))
                  this.cart.classList.remove("is-empty");
                if (!this.error)
                  this.submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading__spinner").classList.add("hidden");
              });
          }
        });
      }
      //Added fix for a case when you add more than available quantity, /cart page was populated with maximumum of available items while drawer was empty.
      updateProductQuantityInCart(productId, quantity) {
        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: productId, quantity: quantity }),
        };

        fetch(`${routes.cart_change_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.success) {
              this.cart.renderContents(response);
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: productId,
                cartData: response,
              });
            } else {
              console.error("Failed to update product quantity:", response);
            }
          })
          .catch((e) => {
            console.error("Error updating product quantity in cart:", e);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
